import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import purchaseQueryKeys from "../purchaseQueryKeys";

const postSetActiveAftermarketPurchase = async (dealId: string) => {
  return api.rawPost(`api/purchases/set-active-aftermarket/${dealId}`);
};

export default function useSetActiveAftermarketPurchaseMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postSetActiveAftermarketPurchase,
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: purchaseQueryKeys.activeAftermarketPurchase(),
      });
    },
  });
}
